"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * Renders an unstyled button HTML element with basic handling of button
 * attributes, e.g., type, onClick, and disabled.
 * 
 * To use, export a styled version of Button with your project's needs.
 * Below is an example of how one might configure a Button that uses an 
 * icon and text.
 * 

  ```
    import { Button as ButtonRaw } from "cosmic-react-conmmon-components";
    
    const Button = props => {
      const { iconName, text, ...rest } = props;

      return (
        <ButtonRaw {...rest}>
          {iconName && (
            <Icon name="iconName" />
          )}
          <Text tag="button">{text}</Text>
        </ButtonRaw>
      );
    };

    export default Button;
  ```
 */


var Button = function Button(_ref) {
  var onClick = _ref.onClick,
      type = _ref.type,
      className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["onClick", "type", "className", "children"]);

  return (// eslint doesn't allow dynamically setting the type
    // eslint-disable-next-line react/button-has-type
    _react.default.createElement("button", _extends({
      type: type,
      className: "CosmicButton ".concat(className),
      onClick: onClick
    }, rest), children)
  );
};

Button.propTypes = {
  onClick: _propTypes.default.func,
  type: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
Button.defaultProps = {
  onClick: null,
  type: "button",
  className: "",
  children: null
};
var _default = Button;
exports.default = _default;